/* eslint-disable no-unused-vars */
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginForm from "./components/LoginForm";
import FormComponent from "./components/FormComponent";
import AllUsers from "./components/AllUsers";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import "./styles/styles.css";
import SuccessPage from "./components/SuccessPage";

function App() {
  return (
    // <Router basename="/form/">
    //   <Routes>
    //     <Route path="/" element={<Home />} />
    //     <Route path="/admin/login" element={<LoginForm />} />
    //     <Route path="/submit" element={<FormComponent />} />
    //     <Route path="/users" element={<AllUsers />} />
    //     <Route path="*" element={<NotFound />} />
    //   </Routes>
    // </Router>
    <Router basename="/navig8-vision-directory-day-1">
      <Routes>
        <Route path="/" element={<FormComponent/>} />
        <Route path="/success" element={<SuccessPage/>}/>
      </Routes>

    </Router>
  );
}

export default App;
